
import { computed, defineComponent, onMounted, ref, toRaw, watch } from "vue";
import WidgetReportInfo from "@/components/widgets/reports/WidgetReportInfo.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { useRouter } from "vue-router";
import useLocale from "@/core/common/useLocale";

interface ReportTab {
  id: string;
  label: string;
  path: string;
}
export default defineComponent({
  name: "widgets-reports",
  inject: ["ismobile"],
  components: {
    WidgetReportInfo,
    // WidgetReportResult,
  },
  setup: function () {
    const store = useStore();
    const fileName = ref("");
    const refWidgetReportInfo = ref();
    const refWidgetReportResult = ref();
    const availableTabs = ref<Array<ReportTab>>([]);
    const router = useRouter();
    const { t } = useLocale();

    enum tabIds {
      CTMS = "ctms",
      VTB = "vtb",
    }

    const tabOptions = [

      {
        id: tabIds.CTMS,
        label: t("CTMS Report"),
        path: "/reports/ctms",
      },
      {
        id: tabIds.VTB,
        label: t("VTB Report"),
        path: "/reports/vtb",
      },
    ] as ReportTab[];
    let link = document.createElement("a");

    onMounted(async () => {
      await store.dispatch(Actions.GET_PATIENT_REPORT_BLOB, {
        req_type: "ctms_download",
      });
    });
    onMounted(async () => {
      setCurrentPageBreadcrumbs("Tables", ["Widgets"]);

      await store.dispatch(Actions.GET_PATIENT_PROCESSES, {});
      await store.dispatch(Actions.GET_PATIENT_REPORT, { req_type: "ctms_summary" });
      await store.dispatch(Actions.GET_PATIENT_VALUES, {
        keyp: "widget_result",
      });
      await store.dispatch(Actions.GET_PATIENT_REPORT_BLOB, {
        req_type: "ctms_download",
      });
      const r = ref();
      r.value = store.getters.getPatientReportBlob;
      if (r.value) {
        link.href = "data:application/octet-stream;base64," + r.value;
        if (fileName.value) {
          link.download = fileName.value;
        } else {
          link.download = "ctms-report.pdf";
        }
      }
      if (showCtmsTab.value) {
        await router.push({ name: "reports.ctms" });
      }

      availableTabs.value = tabOptions.filter(({ id }) =>
        checkIfTabAvailable(id)
      );

      refWidgetReportInfo.value.getPatientValues();
    });
    const getFile = async () => {
      fileName.value = store.getters.getPatientReportFileName;
      link.click();

    };
    watch(
      () => router.currentRoute.value,
      async (value) => {
        if (
          value.path.startsWith("/reports.ctms") &&
          showCtmsTab.value
        ) {
          await router.push({ name: "reports.ctms" });
        }
      }
    );

    const isCtmsTabActive = computed(() => {
      return router.currentRoute.value.name === "reports.ctms";
    });

    const isCtmsReportFileAvailable = computed(() => {
      return !!store.getters.getPatientReportFileName;
    });

    const checkIfTabAvailable = function (id) {
      const idMapper = {
        [tabIds.CTMS]: showCtmsTab.value/*,
        [tabIds.VTB]: showVtbTab.value,*/
      };

      return idMapper[id];
    };



    const patientProcess = computed(() => {
      return store.getters.getPatientProcesses;
    });

    const consentSign = computed(() => {
      return store.getters.getPatientValues.consent_sign;
    });

    const showCtmsTab = computed<boolean>(() => {
      return !!patientProcess.value.ReleaseCTMSReportPatient;
    });

    /*const showVtbTab = computed<boolean>(() => {
      return !!patientProcess.value.ReleaseVTBReportPatient;
    });*/

    const showReportStatus = computed(() => {
      return consentSign.value === 1;
    });

    const showReport = computed(() => {

      //return showCtmsTab.value || showVtbTab.value;
      return showCtmsTab.value;
    });
    return {
      patientProcess,
      consentSign,
      showCtmsTab,
      /*showVtbTab,*/
      showReportStatus,
      refWidgetReportInfo,
      showReport,
      refWidgetReportResult,
      availableTabs,
      isCtmsTabActive,
      isCtmsReportFileAvailable,
      getFile,
    };
  },
});
